// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@guestsupply/App/SharedStyles/CartLineSharedStyles";
import { rfqQuoteDetailsRequestedDetailsGridStyles } from "@guestsupply/Overrides/Widgets/RfqQuoteDetails/RfqQuoteDetailsRequestedDetailsGrid";
import { css } from "styled-components";

rfqQuoteDetailsRequestedDetailsGridStyles.productDescription = {
    ...cartLineSharedStyles.productDescription,
};
rfqQuoteDetailsRequestedDetailsGridStyles.productImage = {
    ...cartLineSharedStyles.productImage,
};
rfqQuoteDetailsRequestedDetailsGridStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};
rfqQuoteDetailsRequestedDetailsGridStyles.extendedUnitNetPriceText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};
rfqQuoteDetailsRequestedDetailsGridStyles.productPrice = {
    ...cartLineSharedStyles.productPrice,
};

rfqQuoteDetailsRequestedDetailsGridStyles.spinnerWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
        height: 300px;
        width: 100%;
    `,
};

rfqQuoteDetailsRequestedDetailsGridStyles.costCodeGridItem = {
    width: 6,
    css: css`
        flex-direction: column;
    `,
};

rfqQuoteDetailsRequestedDetailsGridStyles.costCodeLabelText = {
    weight: "bold",
    css: css`
        margin-bottom: 10px;
        margin-right: 10px;
    `,
};

rfqQuoteDetailsRequestedDetailsGridStyles.footerWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: flex-end;
        margin-top: 20px;
        @media print {
            display: block;
        }
    `,
};

rfqQuoteDetailsRequestedDetailsGridStyles.cartLineContainerStyles = {
    container: {
        css: css`
            grid-template-columns: 91px 2.5fr 1.5fr 1fr 1fr 0;
        `,
    },
};

rfqQuoteDetailsRequestedDetailsGridStyles.linesHeader = {
    wrapper: {
        css: css`
            grid-template-columns: 91px 2.5fr 1.5fr 1fr 1fr 0;
        `,
    },
};

rfqQuoteDetailsRequestedDetailsGridStyles.headerWrapper = {
    css: css`
        display: flex;
        padding-bottom: 15px;
    `,
};
